module.exports = __webpack_public_path__ + "officialStatic/img/kb.540f09c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/smartCampus/role/kb.png
// module id = yXqS
// module chunks = 0